export default __webpack_public_path__ + "static/media/mypic.1d3c54c9.png";